import { useState, useEffect, useRef } from "react";
import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { QuoteButton } from "@/components/common/QuoteButton";
export default function PorcelainPavingHero() {
  const [scrollY, setScrollY] = useState(0);
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const bars = ["Trade discount available", "Free Nationwide Delivery", "Nationwide Showrooms", "Split packs available"];
  return <section ref={sectionRef} className="dark" style={{
    fontFamily: "'Cormorant Garamond', serif"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400;600;700&family=DM+Sans:wght@300;400;500&display=swap');`}</style>

      <div className="bg-background text-foreground overflow-hidden">

        

        <div className="relative grid grid-cols-1 lg:grid-cols-12 lg:min-h-[min(540px,calc(100svh-170px))] lg:h-[calc(100svh-170px)] lg:max-h-[760px]">
          <div className="lg:col-span-6 relative overflow-hidden h-[160px] sm:h-[200px] lg:h-full lg:min-h-full">
            <img alt="Porcelain Paving" className="object-cover absolute top-0 left-0 w-full h-full lg:top-[-10%] lg:h-[120%]" style={{
            transform: `translateY(${Math.min(Math.max(scrollY * 0.08, -30), 40)}px)`
          }} loading="lazy" src="https://nicklandscapes.co.uk/wp-content/uploads/2026/09/dji_fly_20240710_150658_364_1720677986379_photo-scaled.jpg" />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background/80 hidden lg:block" />
            <div className="absolute inset-0 bg-gradient-to-t from-background/60 to-transparent lg:hidden" />
          </div>

          <div className={`lg:col-span-6 relative flex flex-col items-center justify-center text-center px-6 sm:px-8 lg:px-8 xl:px-12 2xl:px-16 py-6 lg:py-6 xl:py-10 bg-background transition-all duration-1000 ${visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="w-full flex flex-col items-center justify-center">
              <div className="space-y-1 lg:space-y-1.5 mb-2.5 lg:mb-4 xl:mb-5 max-w-xl lg:max-w-[28rem] mx-auto">
                <p className="text-xs lg:text-[0.9rem] tracking-[0.3em] uppercase text-muted-foreground" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                  Nick Landscapes
                </p>
                <p className="text-3xl sm:text-4xl lg:text-[2.5rem] xl:text-[3.25rem] font-light text-foreground leading-none tracking-tight" style={{
                fontFamily: "'Cormorant Garamond', serif"
              }}>Trusted</p>
                <h1 className="text-3xl sm:text-4xl lg:text-[2.5rem] xl:text-[3.25rem] 2xl:text-[4rem] font-semibold text-foreground leading-tight tracking-tight italic" style={{
                fontFamily: "'Cormorant Garamond', serif"
              }}>South London Landscapers</h1>
              </div>

              <div className="w-16 lg:w-20 h-px bg-primary mb-2.5 lg:mb-4 xl:mb-5 mx-auto" />

              <p className="text-xs sm:text-sm lg:text-[0.95rem] xl:text-[1.05rem] leading-relaxed text-muted-foreground max-w-md lg:max-w-[29rem] mb-4 lg:mb-5 xl:mb-6 mx-auto text-center" style={{
              fontFamily: "'DM Sans', sans-serif"
            }}>Precision-crafted outdoor spaces. Refined landscapes for residential and commercial transformation.</p>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 w-full max-w-md lg:max-w-[26rem] mx-auto">
                <Button asChild size="lg" className="w-full sm:flex-1 min-w-0 bg-foreground text-background hover:bg-primary hover:text-primary-foreground transition-all duration-300 px-3 py-3 lg:px-4 lg:h-12 text-xs lg:tracking-[0.15em] tracking-[0.25em] uppercase font-medium whitespace-nowrap" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                  <Link to="tel:447459276538" className="flex items-center justify-center gap-2 w-full h-full">
                    <Phone className="size-3 lg:size-4 shrink-0" />
                    <strong>07459276538</strong>
                  </Link>
                </Button>
                <QuoteButton className="w-full sm:flex-1 min-w-0 px-3 py-3 lg:px-4 lg:h-12 text-xs lg:tracking-[0.15em] tracking-[0.25em] whitespace-nowrap" style={{
                fontFamily: "'DM Sans', sans-serif"
              }}>
                  Get A free Quote
                </QuoteButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}